import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function About() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' as const });
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      <main className="pt-20">
        {/* Hero */}
        <section className="py-14 md:py-20 relative overflow-hidden" aria-label="关于被窝影院">
          <div className="absolute inset-0 bg-gradient-to-b from-primary-500/5 to-transparent" />
          <div className="relative max-w-3xl mx-auto px-4 md:px-6 text-center">
            <h1 className="text-3xl md:text-5xl font-bold text-foreground-900 mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
              关于<span className="text-primary-500">被窝影院</span>
            </h1>
            <p className="text-foreground-500 text-base md:text-lg leading-relaxed">
              你的专属追剧天堂，让每一部好剧温暖你的被窝时光
            </p>
          </div>
        </section>

        {/* Brand Introduction */}
        <section className="py-10 md:py-14" aria-label="品牌介绍">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <div className="flex items-center gap-3 mb-8">
              <i className="ri-building-4-line text-primary-500 text-xl"></i>
              <h2 className="text-xl md:text-2xl font-bold text-foreground-900" style={{ fontFamily: 'var(--font-heading)' }}>
                品牌介绍
              </h2>
            </div>
            <div className="space-y-5 text-foreground-600 text-sm md:text-base leading-relaxed">
              <p>
                <strong className="text-foreground-800">被窝影院</strong>成立于2020年，是一家专注于免费电视剧在线观看的内容聚合平台。我们致力于为广大追剧爱好者提供<strong className="text-foreground-800">免费电视剧大全</strong>，让每一位用户都能在被窝里享受<strong className="text-foreground-800">全集在线看</strong>最新电视剧的乐趣。
              </p>
              <p>
                从国产剧到美剧、从韩剧到日剧、从热血动漫到精彩综艺，被窝影院精心筛选海量优质内容，确保每一部剧集都<strong className="text-foreground-800">高清流畅在线不缓冲</strong>。我们深知追剧的快乐在于沉浸式体验，因此不断优化播放技术和用户体验。
              </p>
              <p>
                被窝影院的名字来源于我们对追剧最美好场景的想象——窝在温暖的被窝里，打开手机或平板，进入一个属于自己的追剧世界。无论你身在何处，被窝影院都希望成为你追剧路上的最佳伙伴。
              </p>
            </div>
          </div>
        </section>

        {/* Mission */}
        <section className="py-10 md:py-14 bg-background-100/50" aria-label="我们的使命">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <div className="flex items-center gap-3 mb-8">
              <i className="ri-flag-line text-accent-500 text-xl"></i>
              <h2 className="text-xl md:text-2xl font-bold text-foreground-900" style={{ fontFamily: 'var(--font-heading)' }}>
                我们的使命
              </h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              {[
                {
                  icon: 'ri-movie-2-line',
                  title: '海量资源',
                  desc: '持续扩充剧集库，覆盖国产剧、美剧、韩剧、日剧、动漫等全品类，让你想看什么就有什么。'
                },
                {
                  icon: 'ri-speed-up-line',
                  title: '极致体验',
                  desc: '4K高清画质配合智能加速技术，确保在线看高清流畅不缓冲，追剧体验不打折。'
                },
                {
                  icon: 'ri-heart-line',
                  title: '用户至上',
                  desc: '免费电视剧大全，无需会员，无需付费。我们坚信好内容应该被更多人看到。'
                }
              ].map((item) => (
                <div key={item.title} className="p-6 rounded-lg bg-background-50 border border-background-200/50">
                  <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center mb-4">
                    <i className={`${item.icon} text-primary-600 text-xl`}></i>
                  </div>
                  <h3 className="text-foreground-800 font-semibold text-base mb-2">{item.title}</h3>
                  <p className="text-foreground-500 text-sm leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Reputation */}
        <section className="py-10 md:py-14" aria-label="口碑评价">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <div className="flex items-center gap-3 mb-8">
              <i className="ri-chat-smile-2-line text-primary-500 text-xl"></i>
              <h2 className="text-xl md:text-2xl font-bold text-foreground-900" style={{ fontFamily: 'var(--font-heading)' }}>
                用户口碑
              </h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
              {[
                {
                  name: '小橘子',
                  rating: 5,
                  comment: '被窝影院简直是我的追剧神器！最新电视剧免费看，画质还特别高清，完全不卡顿，每天晚上都窝在被窝里看到停不下来。',
                  date: '2026年7月'
                },
                {
                  name: '追剧达人阿杰',
                  rating: 5,
                  comment: '用了很多追剧平台，被窝影院的体验是最好的。国产剧免费观看资源丰富，更新也快，热播剧完整版播出后没多久就能看了。',
                  date: '2026年7月'
                },
                {
                  name: '夜猫子小美',
                  rating: 4,
                  comment: '分类很清晰，找剧很方便。韩剧和美剧资源都很全，高清流畅在线不缓冲是真的做到了。希望日漫资源能更多一些！',
                  date: '2026年6月'
                },
                {
                  name: '老张看剧',
                  rating: 5,
                  comment: '免费电视剧大全名不虚传，从老剧到新剧都有。全集在线看的体验很好，不用到处找资源，被窝影院一站式搞定。',
                  date: '2026年6月'
                }
              ].map((review) => (
                <div key={review.name} className="p-5 rounded-lg bg-background-100/70 border border-background-200/50">
                  <div className="flex items-center gap-2 mb-3">
                    <div className="w-9 h-9 rounded-full bg-accent-100 flex items-center justify-center">
                      <span className="text-accent-600 text-sm font-bold">{review.name[0]}</span>
                    </div>
                    <div>
                      <div className="text-foreground-800 text-sm font-medium">{review.name}</div>
                      <div className="flex items-center gap-0.5">
                        {Array.from({ length: 5 }, (_, i) => (
                          <i
                            key={i}
                            className={`text-xs ${i < review.rating ? 'ri-star-fill text-primary-500' : 'ri-star-line text-foreground-300'}`}
                          ></i>
                        ))}
                      </div>
                    </div>
                  </div>
                  <p className="text-foreground-600 text-sm leading-relaxed">{review.comment}</p>
                  <p className="text-foreground-400 text-xs mt-3">{review.date}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Contact */}
        <section className="py-10 md:py-14 bg-background-100/50" aria-label="联系方式">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <div className="flex items-center gap-3 mb-8">
              <i className="ri-customer-service-2-line text-accent-500 text-xl"></i>
              <h2 className="text-xl md:text-2xl font-bold text-foreground-900" style={{ fontFamily: 'var(--font-heading)' }}>
                联系我们
              </h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              <div className="p-5 rounded-lg bg-background-50 border border-background-200/50 text-center">
                <div className="w-12 h-12 mx-auto rounded-full bg-primary-100 flex items-center justify-center mb-3">
                  <i className="ri-mail-line text-primary-600 text-xl"></i>
                </div>
                <h3 className="text-foreground-800 font-semibold text-sm mb-1">电子邮箱</h3>
                <p className="text-foreground-500 text-sm">contact@beiwoyingyuan.com</p>
              </div>
              <div className="p-5 rounded-lg bg-background-50 border border-background-200/50 text-center">
                <div className="w-12 h-12 mx-auto rounded-full bg-accent-100 flex items-center justify-center mb-3">
                  <i className="ri-time-line text-accent-600 text-xl"></i>
                </div>
                <h3 className="text-foreground-800 font-semibold text-sm mb-1">工作时间</h3>
                <p className="text-foreground-500 text-sm">周一至周五 9:00 - 18:00</p>
              </div>
              <div className="p-5 rounded-lg bg-background-50 border border-background-200/50 text-center">
                <div className="w-12 h-12 mx-auto rounded-full bg-secondary-100 flex items-center justify-center mb-3">
                  <i className="ri-map-pin-line text-secondary-600 text-xl"></i>
                </div>
                <h3 className="text-foreground-800 font-semibold text-sm mb-1">公司地址</h3>
                <p className="text-foreground-500 text-sm">北京市朝阳区望京科技园</p>
              </div>
            </div>
          </div>
        </section>

        {/* Contact Form */}
        <section className="py-10 md:py-14" aria-label="意见反馈">
          <div className="max-w-lg mx-auto px-4 md:px-6">
            <h2 className="text-xl font-bold text-foreground-900 text-center mb-2" style={{ fontFamily: 'var(--font-heading)' }}>
              意见反馈
            </h2>
            <p className="text-foreground-500 text-sm text-center mb-8">有任何建议或问题，欢迎随时告诉我们</p>
            <form
              className="space-y-4"
              data-readdy-form
              onSubmit={async (e) => {
                e.preventDefault();
                const form = e.currentTarget;
                const formData = new FormData(form);
                const honeypot = formData.get('website_alt') as string;
                if (honeypot && honeypot.trim()) {
                  alert('提交成功，感谢您的反馈！');
                  form.reset();
                  return;
                }
                formData.delete('website_alt');
                try {
                  const res = await fetch('https://readdy.ai/api/form/d9niaje8mbnljin5a180', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    body: new URLSearchParams(formData as unknown as Record<string, string>).toString()
                  });
                  const responseText = await res.text();
                  let parsed;
                  try { parsed = JSON.parse(responseText); } catch { parsed = {}; }
                  if (res.ok && parsed?.code === 'OK') {
                    alert('提交成功，感谢您的反馈！');
                    form.reset();
                  } else {
                    const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
                    alert(serverMsg || '提交失败，请稍后再试');
                  }
                } catch {
                  alert('网络错误，请稍后重试');
                }
              }}
            >
              <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
              <div>
                <label htmlFor="contact-name" className="block text-foreground-600 text-sm mb-1.5">姓名</label>
                <input
                  id="contact-name"
                  name="name"
                  type="text"
                  required
                  className="w-full h-10 px-4 rounded-lg bg-background-100 border border-background-200/60 text-sm text-foreground-700 placeholder-foreground-400 focus:outline-none focus:border-primary-500/50 transition-colors"
                  placeholder="请输入您的姓名"
                />
              </div>
              <div>
                <label htmlFor="contact-email" className="block text-foreground-600 text-sm mb-1.5">邮箱</label>
                <input
                  id="contact-email"
                  name="email"
                  type="email"
                  required
                  className="w-full h-10 px-4 rounded-lg bg-background-100 border border-background-200/60 text-sm text-foreground-700 placeholder-foreground-400 focus:outline-none focus:border-primary-500/50 transition-colors"
                  placeholder="请输入您的邮箱"
                />
              </div>
              <div>
                <label htmlFor="contact-message" className="block text-foreground-600 text-sm mb-1.5">反馈内容</label>
                <textarea
                  id="contact-message"
                  name="message"
                  required
                  maxLength={500}
                  rows={4}
                  className="w-full px-4 py-3 rounded-lg bg-background-100 border border-background-200/60 text-sm text-foreground-700 placeholder-foreground-400 focus:outline-none focus:border-primary-500/50 transition-colors resize-none"
                  placeholder="请描述您的建议或问题（500字以内）"
                ></textarea>
              </div>
              <button
                type="submit"
                className="w-full h-11 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                提交反馈
              </button>
            </form>
          </div>
        </section>

        {/* Schema.org */}
        <script type="application/ld+json" dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "AboutPage",
            "name": "关于被窝影院",
            "description": "被窝影院 - 免费电视剧大全、全集在线看，最新电视剧免费热播剧完整版，国产剧免费观看高清流畅在线",
            "url": "https://www.beiwoyingyuan.com/about",
            "isPartOf": {
              "@type": "WebSite",
              "name": "被窝影院",
              "url": "https://www.beiwoyingyuan.com/"
            }
          })
        }} />
        <script type="application/ld+json" dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              { "@type": "ListItem", "position": 1, "name": "首页", "item": "https://www.beiwoyingyuan.com/" },
              { "@type": "ListItem", "position": 2, "name": "关于我们", "item": "https://www.beiwoyingyuan.com/about" }
            ]
          })
        }} />
      </main>

      <Footer />
    </div>
  );
}